<template>
  <div class="after-bootcamp">
    <h3 class="section-subtitle">{{ afterBootcamp.subtitle }}</h3>
    <h2 class="section-title">{{ afterBootcamp.title }}</h2>
    <div class="inner-container">
      <BootcampDiscord v-if="discord" :discord="discord" />
      <BootcampTrainingPlan
        v-if="trainingPlans"
        :trainingPlans="trainingPlans"
      />
      <BootcampTwitch v-if="twitch" :twitch="twitch" />
      <ImageBenefit v-if="imageBenefit" :imageBenefit="imageBenefit" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  components: {
    BootcampDiscord: () =>
      import("@/components/bootcamp/enroll/after/BootcampDiscord.vue"),
    BootcampTrainingPlan: () =>
      import("@/components/bootcamp/enroll/after/BootcampTrainingplan.vue"),
    BootcampTwitch: () =>
      import("@/components/bootcamp/enroll/after/BootcampTwitch.vue"),
    ImageBenefit: () =>
      import("@/components/bootcamp/enroll/after/ImageBenefit.vue"),
  },
  computed: {
    ...mapGetters("BootcampEnroll", ["afterBootcampByKey"]),
    key () {
      return this.$route.params.key || this.$route.path.replace("/", "")
    },
    afterBootcamp () {
      return this.afterBootcampByKey(this.key)
    },
    discord () {
      return this.afterBootcamp.discord
    },
    trainingPlans () {
      return this.afterBootcamp.trainingPlans
    },
    twitch () {
      return this.afterBootcamp.twitch
    },
    imageBenefit () {
      return this.afterBootcamp.imageBenefit
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.after-bootcamp {
  padding-top: 7.7rem;
  @include phone-down {
    padding-top: 4.1rem;
  }
  background: #fff;
  width: 100%;
  .inner-container {
    max-width: 92rem;
    margin: 0 auto;
    width: 95%;
  }
  >>> .section-sub-subtitle {
    display: flex;
    align-items: center;
    text-align: left;
    font-weight: 500;
    font-size: 2rem;
    line-height: 148.5%;
    color: #0b0a1c;
    .check {
      margin-right: 0.9rem;
    }
    @include phone-down {
      font-size: 1.6rem;
      line-height: 2.4rem;
      align-items: flex-start;
      .check {
        margin-top: 0.5rem;
      }
    }
  }
  >>> .underline {
    opacity: 0.4;
    background: #f42556;
    width: 27.9rem;
    height: 0.3rem;
    margin-top: 1.3rem;
    @include phone-down {
      margin-left: 2rem;
      margin-top: 1.1rem;
    }
  }
  >>> .section-sub-description {
    font-weight: 300;
    font-size: 1.4rem;
    line-height: 148.5%;
    color: #545460;
    text-align: left;
    margin-top: 1.3rem;
    @include phone-down {
      font-size: 1.2rem;
      margin-left: 2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/after/TheAfterBootcamp.vue